/* import __COLOCATED_TEMPLATE__ from './channel-fields-step.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class RequestStepsChannelFieldsStep extends Component {}
